
import {Component, OnInit} from '@angular/core';
import {ViewManagerService} from "src/app/services/view-manager.service";
import {DashboardService} from "./dashboard.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(
    private dashboardService: DashboardService,
    private viewManager: ViewManagerService
  ) {
  }

  ngOnInit(): void {
    this.dashboardService.init();
  }

  getReports() {
    return this.dashboardService.reports;
  }

  getStatuses() {
    return this.dashboardService.statuses;
  }

}
